<template>
  <select v-model="model" class="st-control" :class="{ 'st-control--shell': onShell }">
    <slot />
  </select>
</template>

<script setup lang="ts">
const model = defineModel<string | number | null>();
defineProps<{ onShell?: boolean }>();
</script>
